import { useEffect, useState } from 'react';
export const useViewportSize = (excludeScrollbarWidth = true)=>{
    const [width, setWidth] = useState(null);
    const [height, setHeight] = useState(null);
    const [scrollbarWidth, setScrollbarWidth] = useState(0);
    useEffect(()=>{
        const updateDimensions = ()=>{
            const bodyWidth = document.body.clientWidth;
            const scrollbarWidthMax = 17;
            const calculatedScrollbarWidth = Math.min(scrollbarWidthMax, window.innerWidth - bodyWidth);
            setWidth(excludeScrollbarWidth ? window.innerWidth - calculatedScrollbarWidth : window.innerWidth);
            setHeight(window.innerHeight);
            setScrollbarWidth(calculatedScrollbarWidth);
        };
        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        return ()=>window.removeEventListener('resize', updateDimensions);
    }, [
        excludeScrollbarWidth
    ]);
    return {
        width,
        height,
        scrollbarWidth
    };
};

//# sourceMappingURL=useViewportSize.js.map